import axios from 'axios'

export type SendFacebookFormDto = {
  firstName: string
  lastName: string
  email: string
  address: {
    name: string
    value: string
  }
  role: string
  isFacebookPageManager: boolean
  facebookUrl: string
  token: string
}

function getPersona(type: string): string {
  switch (type) {
    case 'living':
      return 'persona_2'
    case 'working':
      return 'persona_3'
    case 'elected-official':
      return 'persona_4'
    default:
      return ''
  }
}

export async function sendFacebookForm(
  data: SendFacebookFormDto,
): Promise<void> {
  await axios.post(
    `https://us-central1-resident-75c1b.cloudfunctions.net/submitEarlyAccessForm`,
    {
      token: data.token,
      fields: [
        {
          name: 'firstname',
          value: data.firstName,
        },
        {
          name: 'lastname',
          value: data.lastName,
        },
        {
          name: 'email',
          value: data.email,
        },
        {
          name: 'address',
          value: data.address.name,
        },
        {
          name: 'placeid',
          value: data.address.value,
        },
        {
          name: 'facebook',
          value: data.facebookUrl || '',
        },
        {
          name: 'hs_persona',
          value: getPersona(data.role),
        },
      ],
    },
  )
}
